import { FunctionComponent } from "react";
import { InviteAdminSliderAdminPartials } from "../../../../partials/admin/menus/users/invite-admin-slider.admin.partials";

export const InviteAdminSliderAdminScreen: FunctionComponent = () => {
  return <InviteAdminSliderAdminPartials />;
};
